import EpiComponent from '@episerver/spa-core/EpiComponent';
import React, {ReactNode, ReactNodeArray} from 'react';
import IdfOrderSummaryBlockData from '../../../Models/Content/IdfOrderSummaryBlockData';
import OrderSummary from './OrderSummaryMainPage';

export default class IdfOrderSummaryBlock extends EpiComponent<IdfOrderSummaryBlockData> {
  constructor(props) {
    super(props);
  }

  public render(): ReactNode | ReactNodeArray | null {
    return <OrderSummary context={this.getContext()} iContent={this.props.data} />;
  }
}
